import { DEPRECATED_STEPS, STEPS } from 'apps/fleet-planner/components/activation/Steps'

interface IGetDeprecatedStepCount {
  bcaPart: number
  currentStep: keyof typeof DEPRECATED_STEPS
}

interface IGetStepCount {
  bcaPart: number
  currentStep: keyof typeof STEPS
  isSafetyLetterNeeded?: boolean
}

/**
 * @param {number} bcaPart - current part of BCA form to show
 * @param {keyof typeof STEPS} currentStep - current step in activation flow
 * @returns {string} - step count in format of 'x of y'
 * @example
 * getStepCount({
 *  bcaPart: 1,
 * currentStep: 'bca',
 * })
 * // => 'Step 1 of 3'
 */

export const getDeprecatedStepCount = ({ bcaPart, currentStep }: IGetDeprecatedStepCount) => {
  const AMOUNT_OF_STEPS = '3'
  const { step } = DEPRECATED_STEPS[currentStep] || { step: 0 }
  if (currentStep === 'bca' && bcaPart === 1) {
    return `Step 1 of ${AMOUNT_OF_STEPS}`
  }
  return `Step ${step + 1} of ${AMOUNT_OF_STEPS}`
}

export const getStepCount = ({ bcaPart, currentStep, isSafetyLetterNeeded }: IGetStepCount) => {
  const AMOUNT_OF_STEPS = isSafetyLetterNeeded ? '5' : '4'
  const { step } = STEPS[currentStep] || { step: 0 }
  if (currentStep === 'bca' && bcaPart === 1) {
    return `Step 1 of ${AMOUNT_OF_STEPS}`
  }
  if (currentStep === 'insurance') {
    return `Step 3 of ${AMOUNT_OF_STEPS}`
  }
  return `Step ${step + 1} of ${AMOUNT_OF_STEPS}`
}
